import axios from "axios";

const TOKEN_KEY = 'jwt_token';
const MAP_KEY_STORAGE = 'app_map_api_key';
const MAP_ID_STORAGE  = 'app_map_id';

export type JwtResponse = {
    token: string;
    react_google_map_api_key: string;
    react_google_map_id: string;
};

export async function fetchJwtToken(): Promise<JwtResponse> {
    const res = await axios.get<JwtResponse>('/gw/api/jwt');
    const { token, react_google_map_api_key, react_google_map_id } = res.data;

    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(MAP_KEY_STORAGE, react_google_map_api_key);
    localStorage.setItem(MAP_ID_STORAGE, react_google_map_id);
    return res.data;
}

export function getJwtToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
}

export function getMapApiKey(): string | null {
    return localStorage.getItem(MAP_KEY_STORAGE);
}

export function getMapId(): string | null {
    return localStorage.getItem(MAP_ID_STORAGE);
}